import React, { useState } from 'react';
import { CloudImage } from '@components/CloudImage';
import Carousel from 'nuka-carousel';
import { careersPageData } from '@data-ts/pages/careers';
import {
  WrapperBox,
  StyledCloudImage,
  Heading,
  StyledTextPairing,
  MobileStyledBox,
  ValueTextPairing,
  MobileForegroundBox,
  MobileForegroundGridBox,
  CarouselItem,
} from './OurValues.styles';

export const OurValuesMobile: React.FC = () => {
  const [loaded, setLoaded] = useState(false);
  const ourValuesData = careersPageData.ourValues;
  return (
    <WrapperBox paddingTop={11} paddingBottom={[11, 12, 14]}>
      <StyledCloudImage src="careers/values/bg-gradients.png" width="100%" />
      <Heading paddingX={7}>
        <StyledTextPairing
          eyebrow={ourValuesData.eyebrow}
          eyebrowVariant="sectionEyeBrow24"
          eyebrowColor={'humana4'}
          eyebrowTagName="h3"
          title={ourValuesData.title}
          titleVariant="hed56"
          titleColor={'neutra6'}
          titleTagName="h3"
          body={ourValuesData.body}
          bodyVariant="dek20"
          bodyColor={'neutra5'}
          textAlign="center"
          alignment={'center'}
        />
      </Heading>
      <MobileStyledBox marginX={10}>
        <Carousel
          renderBottomCenterControls={null}
          renderCenterLeftControls={null}
          renderCenterRightControls={null}
          autoplay={false}
          cellAlign={'left'}
          slidesToShow={1.3}
          wrapAround={true}
          speed={500}
          easing="easeSinInOut"
          disableEdgeSwiping={false}
        >
          {ourValuesData.values.map((mobileValue, index: number) => (
            <CarouselItem key={index}>
              <ValueTextPairing
                icon={mobileValue.icon}
                iconColor="mono1"
                iconSize={24}
                title={mobileValue.title}
                titleVariant="calloutDek40"
                titleColor="neutra6"
                titleMaxWidth={'245px'}
                titleTagName="h3"
                body={mobileValue.body}
                bodyVariant="featureCopy17"
                bodyColor="neutra5"
                bodyMaxWidth="240px"
              />
            </CarouselItem>
          ))}
        </Carousel>
      </MobileStyledBox>
      <MobileForegroundGridBox loaded={loaded}>
        <CloudImage src={'careers/values/fg-grid-v4.svg'} onLoad={() => setLoaded(true)} width="175%" />
      </MobileForegroundGridBox>
      <MobileForegroundBox>
        <CloudImage src={'careers/values/fg-curls-v2.svg'} width="100%" />
      </MobileForegroundBox>
    </WrapperBox>
  );
};
